import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import {OptionService} from "../option/option.service";

interface GenderResponse {
  gender: 'M' | 'F' | null;
}

@Injectable({
  providedIn: 'root'
})
export class GenderService {
  /**
   * URL for getting the firstname from the API
   * @private
   */
  private apiUrl = 'firstname/';

  /**
   * constructor
   * @param http
   */
  constructor(private http: HttpClient) {}

  /**
   * get gender from lookup api
   * @param name
   * @returns Observable
   */
  private getGenderFromAPI(name: string): Observable<'M' | 'F' | null> {
    const host = OptionService.getLookupHost();

    return this.http.get<GenderResponse>(`${host}${this.apiUrl}${name}`).pipe(
      map((response: GenderResponse) => response.gender),
      catchError((error: any) => {
        // in case of error return null
        return of(null);
      })
    );
  }

  /**
   * get gender for name and handle space and dashes
   * @param fullname
   * @returns
   */
  getGenderForName(fullname: string): Observable<'M' | 'F' | null> {
    // if name has a dash only use the first part
    const firstname = fullname.split('-')[0];

    return this.getGenderFromAPI(firstname).pipe(
      switchMap((gender: 'M' | 'F' | null) => {
        // if there is no gender found and name has a space
        if (gender === null && firstname.indexOf(' ') !== -1) {
          // split and try again
          const firstNamePart = firstname.split(' ')[0];
          return this.getGenderFromAPI(firstNamePart);
        }
        else {
          return of(gender);
        }
      })
    );
  }
}
